import { Component, Input } from '@angular/core';
import { FormService } from '../../../common/services/form.service';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { Field } from 'src/sb-tools/typescript/models/field.model';
import { ClientField } from '../../../common/models/client-field.model';
import { FocusDirective } from '@sb-tools/typescript/directives/focus.directive';
import { WhitespaceValidatorDirective } from '@form-field-module/common/directives/whitespace-validator.directive';
import { FormFieldLabelComponent } from '@form-field-module/common/components/form-field-label/form-field-label.component';

@Component({
    selector: 'sb-title',
    templateUrl: './title.component.html',
    styleUrls: ['./title.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [FocusDirective, FormsModule, WhitespaceValidatorDirective, FormFieldLabelComponent],
})
export class TitleComponent {
    @Input() formField: Field | ClientField;

    constructor(public formService: FormService) {}
}
